import { IconMapBus16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { Body1, Body2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './GeoTravelTime.css';
import { ETransportType } from 'shared/types/geo';

interface IGeoTravelTimeProps {
  transportType: ETransportType;
  time: string;
  small?: boolean;
}

export const GeoTravelTime: React.FC<IGeoTravelTimeProps> = ({ transportType, time, small }) => {
  const Icon = transportType === ETransportType.Walk ? IconMapWalk16 : IconMapBus16;
  const Component = small ? Body2 : Body1;

  return (
    <div className={styles['container']}>
      <div data-name={transportType} className={styles['icon']}>
        <Icon display="block" color="icon-secondary-default" />
      </div>

      <Component display="inline" color="theme-gray">
        {time}
      </Component>
    </div>
  );
};
